import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Wrapper, Content, Description, BoldDescription, FeatureImage, TitleWrapper, TitleBold
} from './styled';
import Button from 'shared/ui/Button';
import { URL_PRICING } from 'store/License/actions';

const UpgradeLicense = ({ image, descriptionIntlId }) => {
  const intl = useIntl();
  const onClick = () => window.open(URL_PRICING);

  return (
    <Wrapper>
      <FeatureImage src={ image } />
      <Content>
        <TitleWrapper>
          <FormattedMessage id="upgradeLicense.sidebar.titleForMoreFeatures" values={ { b: (chunks) => <TitleBold children={ chunks } /> } } />
        </TitleWrapper>
        <Description>
          <FormattedMessage
            id={ descriptionIntlId }
            values={ {
              b: (chunks) => <BoldDescription children={ chunks } />,
              br: <br />
            } }
          />
        </Description>
        <Button onClick={ onClick }>{ intl.formatMessage({ id: 'upgradeLicense.sidebar.upgradeNow' }) }</Button>
      </Content>
    </Wrapper>
  );
};

UpgradeLicense.propTypes = {
  descriptionIntlId: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired
};

export default UpgradeLicense;
